import React from 'react';
import { ENDPOINT } from './config.js';
import normalizeFont from './normalizeFont.js';

/**
 * Generates @font-face declarations for all given fonts, variants and formats
 * @param fonts {Font[]} the font family or families to define
 * @param variants {Variant[]} the variant to define
 * @param formats {Format[]} the format(s) to define
 * @returns {React.ReactElement} the style node with our @font-face-declarations
 *
 * [1] Loop through all fonts
 * [2] Loop through all formats
 * [3] Add the src attribute which is the url to fonts-api
 * [4] Set the style based on the variant
 * [5] Set the weight
 *
 */

var createFontFace = function createFontFace(fonts, variants, formats) {
  return React.createElement("style", null, fonts.map(function (font) {
    // [1]
    return variants.map(function (variant) {
      // [2]
      return "\n@font-face {\n  font-family: " + font + ";\n  src:" + formats.map(function (format, index) {
        // [3]
        return " url('" + ENDPOINT + normalizeFont(font) + "/" + variant + "/" + format + "') format('" + format + "')" + (index !== formats.length - 1 ? '' : ';');
      }) + "\n  font-display: swap;\n  font-style: " + (variant.charAt(0) === 'i' ? 'italic' : 'normal'
      /* [4] */
      ) + ";\n  font-weight: " + variant.charAt(1)
      /* [5] */
      + "00\n        }";
    });
  }));
};

export default createFontFace;
